import { render, staticRenderFns } from "./homepage.tt.vue?vue&type=template&id=3d7535b2&scoped=true"
import script from "./homepage.tt.vue?vue&type=script&lang=js"
export * from "./homepage.tt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7535b2",
  null
  
)

export default component.exports